import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { DatePipe } from '@angular/common';
import { ImpersonationAuditLog } from '../models/impersonation-audit.model';

@Component({
  selector: 'app-impersonation-log-detail',
  standalone: true,
  templateUrl: './impersonation-log-detail.component.html',
  styleUrl: './impersonation-log-detail.component.scss',
  imports: [MatDialogModule, DatePipe]
})
export class ImpersonationLogDetailComponent {
  constructor(
    public dialogRef: MatDialogRef<ImpersonationLogDetailComponent>,
    @Inject(MAT_DIALOG_DATA) public log: ImpersonationAuditLog
  ) {}

  close(): void {
    this.dialogRef.close();
  }

  get prettyBody(): string {
    if (!this.log.RequestBody) return '';
    try {
      return JSON.stringify(JSON.parse(this.log.RequestBody), null, 2);
    } catch {
      return this.log.RequestBody;
    }
  }
}
